'use client'

/**
 * The grants Search & Remediate's API checks (er-snr.controller.ts, er-snr-v2.controller.ts), for the
 * console's role gates — so every control names the check of the call it makes, from one place.
 *
 * Trash and Delete stay, behind their permissions (owner, 27 Oct 2026): every verb needs `update`, and a
 * permanent Delete needs delete:ErHardDelete TOO (plus the workspace switch and a provider that grants it:
 * snr-verb-gate.ts says which one is missing, in words, on the control).
 */
import type { PermissionRequirement } from '@/lib/auth/permissions'

/** View runs, results and headers. */
export const SNR_READ: PermissionRequirement = { action: 'read', subject: 'ErSearchRemediate' }

/** POST /compile, /dry-runs, /runs, and saved searches: starting a search. */
export const SNR_SEARCH: PermissionRequirement = { action: 'create', subject: 'ErSearchRemediate' }

/**
 * Every remediation verb (preview, confirm, Undo, Retry failed), and pause / resume /
 * cancel of a search.
 */
export const SNR_REMEDIATE: PermissionRequirement = { action: 'update', subject: 'ErSearchRemediate' }

/**
 * Attack Watch's writes that change a watch: PATCH /er/attack-watch/fingerprints/:id (rename, what happens on a new
 * wave, Pause / Resume, Extend, Watch again, End now). The same grant the S&R verbs need.
 */
export const ATTACK_WATCH_CHANGE: PermissionRequirement = { action: 'update', subject: 'ErSearchRemediate' }

/** A permanent Delete needs this TOO, on top of SNR_REMEDIATE (the API's Delete gate, reason `role`). */
export const SNR_HARD_DELETE: PermissionRequirement = { action: 'delete', subject: 'ErHardDelete' }
